module.exports = __webpack_public_path__ + "static/media/averta-semibold.afe34790.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/averta-semibold.woff2
// module id = 849
// module chunks = 4